import type { ITicketPersonalLoanDetails } from './TicketPersonalLoanDetails.interface';
import { TicketPersonalLoanPurpose } from './TicketPersonalLoanPurpose.enum';

export default class TicketPersonalLoanDetails implements ITicketPersonalLoanDetails {
  lender: string;
  loanPurpose: TicketPersonalLoanPurpose;
  financeTerm: number;
  financeAmount: number;
  interestRate: number;
  monthlyRepayment: number;
  accountNumber: string;

  static build = (data: ITicketPersonalLoanDetails) => new TicketPersonalLoanDetails(data);
  static blank = () => new TicketPersonalLoanDetails();

  /**
   * Constructor
   * @param {ITicketPersonalLoanDetails} data
   */
  constructor(data?: ITicketPersonalLoanDetails) {
    this.lender = data?.lender || '';
    this.loanPurpose = TicketPersonalLoanPurpose.of(
      data?.loanPurpose?.name || data?.loanPurpose?.toString()
    );
    this.financeTerm = parseInt(data?.financeTerm || 0, 10);
    this.financeAmount = parseFloat(data?.financeAmount || 0);
    this.interestRate = parseFloat(data?.interestRate || 0);
    this.monthlyRepayment = parseFloat(data?.monthlyRepayment || 0);
    this.accountNumber = data?.accountNumber || '';
  }
}
